import React, { useState } from 'react';

const LoadingBanner = ({
  showBanner,
  loadingText = 'Thinking...',
  backgroundColor,
  borderColor,
  textColor,
}) => {
  const bannerStyle = {};
  if (backgroundColor) {
    bannerStyle.backgroundColor = backgroundColor;
  }
  if (borderColor) {
    bannerStyle.borderColor = borderColor;
    bannerStyle.borderStyle = 'solid';
  }
  if (textColor) {
    bannerStyle.color = textColor;
  }
  return (
    <div>
      {showBanner && (
        <div className="banner" style={bannerStyle}>
          {loadingText}
        </div>
      )}
    </div>
  );
};

export default LoadingBanner;
